/*
  lien-sort.js — İndirim oranına göre sıralama (istemci tarafı).
  Shopify koleksiyon sıralamasında "indirim oranı" yok. Müşteri istedi;
  sayfada yüklü kartlar (product-card[data-lpc-discount]) DOM'da yeniden
  sıralanır. Sayfalama varsa yalnızca o sayfa sıralanır (main-collection
  50/sayfa yapıldı). Yalnızca DOM sırası değişir; layout animasyonu yok.
*/
(() => {
  const KEY = 'lien:sort';

  function grids() {
    return Array.from(document.querySelectorAll('.product-grid'));
  }

  function itemsOf(grid) {
    return Array.from(grid.children).filter((el) => el.querySelector('product-card[data-lpc-discount]'));
  }

  function discountOf(item) {
    const card = item.querySelector('product-card[data-lpc-discount]');
    return card ? parseInt(card.dataset.lpcDiscount || '0', 10) || 0 : 0;
  }

  function apply(mode) {
    const dir = mode === 'lien-discount-asc' ? 1 : -1;
    grids().forEach((grid) => {
      const items = itemsOf(grid);
      if (items.length < 2) return;
      const sorted = items
        .map((el, i) => ({ el, i, d: discountOf(el) }))
        .sort((a, b) => (a.d - b.d) * dir || a.i - b.i);
      const frag = document.createDocumentFragment();
      sorted.forEach(({ el }) => frag.appendChild(el));
      grid.appendChild(frag);
    });
  }

  function setStatus(root, label) {
    // `.facets__status` filtre panellerinde de var (Stok durumu, Fiyat).
    // Etiketi YALNIZCA sıralama bileşeninin içine yaz; yoksa filtre
    // başlıklarının yanına "İndirim oranı..." basılıyordu.
    root.querySelectorAll('sorting-filter-component .facets__status').forEach((el) => (el.textContent = label));
    root.querySelectorAll('.sorting-filter__option[role="option"]').forEach((opt) => {
      const on = opt.dataset.lienSort && opt.dataset.lienSort === current;
      opt.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  let current = null, currentLabel = '';
  try { current = sessionStorage.getItem(KEY); currentLabel = sessionStorage.getItem(KEY + ':label') || ''; } catch (e) {}

  function handle(value, label, root) {
    current = value; currentLabel = label;
    try { sessionStorage.setItem(KEY, value); sessionStorage.setItem(KEY + ':label', label); } catch (e) {}
    apply(value);
    setStatus(root, label);
    // Açık paneli kapat
    root.querySelectorAll('details[open]').forEach((d) => { d.open = false; });
  }

  // Yakalama aşamasında dinle: temanın kendi change işleyicisine (facets.js)
  // ulaşmadan durdur; Shopify'a geçersiz sort_by göndermeyelim.
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement || t instanceof HTMLSelectElement)) return;
    const value = t.value || '';
    if (!value.startsWith('lien-')) {
      if (current) { current = null; currentLabel = ''; try { sessionStorage.removeItem(KEY); sessionStorage.removeItem(KEY + ':label'); } catch (err) {} }
      return;
    }
    e.stopImmediatePropagation();
    e.preventDefault();
    const root = t.closest('sorting-filter-component') || document;
    const label = t instanceof HTMLSelectElement
      ? (t.selectedOptions[0] && t.selectedOptions[0].textContent.trim()) || ''
      : t.dataset.optionName || '';
    // select'i tema yeniden render ederse değer sıfırlanmasın diye seçili bırak
    handle(value, label, root);
  }, true);

  // Sayfa (tema tarafından) yeniden render edildiğinde sırayı koru
  const mo = new MutationObserver(() => {
    if (!current) return;
    clearTimeout(mo._t);
    // Tema yeniden çizince (facets.js morph) hem sırayı hem etiketi geri koy
    mo._t = setTimeout(() => { apply(current); setStatus(document, currentLabel); }, 60);
  });
  document.addEventListener('DOMContentLoaded', () => {
    const main = document.querySelector('.product-grid')?.closest('.shopify-section') || document.body;
    mo.observe(main, { childList: true, subtree: true });
    if (current) { apply(current); setStatus(document, currentLabel); }
  });
  if (document.readyState !== 'loading' && current) { apply(current); setStatus(document, currentLabel); }
})();
